<template>
	<div>
		<div>
			<Button type="primary" icon="ios-search" @click="showSearch">搜索</Button>
		</div>

		<Modal title="Title" v-model="searchModal" :mask-closable="false" width="380">
			<p slot="header" style="color:#0066FF;text-align:center">
				<span>搜索</span>
			</p>
			<div style="padding-left: 20px;">
				<CheckboxGroup v-model="selectedConditions" class="check_group">
					<div>
						<Checkbox label="id">
							<span>消息编号</span>
						</Checkbox>
						<Input v-model="condition.id" placeholder="" />
					</div>
					<div>
						<Checkbox label="num">
							<span>设备编号</span>
						</Checkbox>
						<Input v-model="condition.num" placeholder="" />
					</div>
					<div>
						<Checkbox label="subType">
							<span>类型</span>
						</Checkbox>
						<Select v-model="condition.subType" placeholder="">
							<Option v-for="(item,index) in boxProfile.errorTrig" :value="index">{{item.cn}}</Option>
						</Select>
					</div>
					<div>
						<Checkbox label="happenTime">
							<span>时间范围</span>
						</Checkbox>
						<Tooltip transfer placement="top" :disabled="condition.happenTimeRange[0] == ''">
							<div slot="content">
								<span>{{dateFtt('yyyy-MM-dd hh:mm:ss',condition.happenTimeRange[0])}}</span>
								<br />
								<span style="margin-left:50%">~</span>
								<br />
								<span>{{dateFtt('yyyy-MM-dd hh:mm:ss',condition.happenTimeRange[1])}}</span>
							</div>
							<DatePicker v-model="condition.happenTimeRange" type="daterange" split-panels
								placeholder=""></DatePicker>
						</Tooltip>
					</div>
				</CheckboxGroup>
			</div>
			<div slot="footer">
				<Button type="info" size="large" long @click="searchByCondition">立即搜索</Button>
			</div>
		</Modal>

		<br />
		<Table size="large" border stripe :loading="loading" :columns="columns1" :data="data1">
			<template slot-scope="{ row, index }" slot="action">
				<Button type="primary" shape="circle" icon="ios-apps" @click="showData(row, index)"></Button>
			</template>
		</Table>
		<br />

		<Page :current="currentPage" :total="totalRows" :page-size="pageSize" :page-size-opts="[5, 10, 20, 30, 40, 50]"
			show-sizer show-total @on-change="changePage" @on-page-size-change="changePageSize" />
	</div>
</template>

<script>
	import {
		constants
	} from "crypto";
	export default {
		name: "meter_alarm_download_info",
		data() {
			let that = this;
			return {
				boxProfile: {},
				data1: [],
				loading: true,
				showDrawer: false,
				selectDataHtml: '',
				selectData: {},
				searchModal: false,
				currentPage: 1,
				pageSize: 30,
				totalRows: 0,
				selectedConditions: [],
				condition: {
					id: '',
					mac: '',
					subType: '',
					happenTimeRange: [],
				},
				requestBody: {},
				columns1: [
					{
						title: "姓名",
						key: "name",
						align: "center",
						width: 100,
					},
					{
						title: "电话",
						key: "telephone",
						align: "center",
						width: 200,
					},
					{
						title: "地址",
						key: "address",
						align: "center",
						width: 300,
        			},
					{
						title: "消息编号",
						key: "id",
						align: "center",
						width: 100
					},
					{
						title: "设备编号",
						key: "num",
						align: "center",
						width: 200
					},
					{
						title: "类型",
						key: "subType",
						align: "center",
						width: 150,
						render: function(h, params) {
							let subType = that.boxProfile[params.row.mainType][params.row.subType];
							return h(
								"div",
								subType == null ? '未匹配：' + params.row.subType : subType.cn
							);
						}
					},
					{
						title: "下发时间",
						align: "center",
						width: 200,
						render: function(h, params) {
							try {
								if (params.row.happenTime != undefined) {
									let timeStr = global.dateFtt(
										"yyyy-MM-dd hh:mm:ss",
										new Date(params.row.happenTime)
									);
									return h("div", timeStr == "" ? "设备未校时" : timeStr);
								}
							} catch (err) {
								return h("div", "JSON格式错误");
							}
						}
					},
					{
						title: "接收时间",
						align: "center",
						width: 200,
						render: function(h, params) {
							try {
								if (params.row.receiveTime != undefined) {
									let timeStr = global.dateFtt(
										"yyyy-MM-dd hh:mm:ss",
										new Date(params.row.receiveTime)
									);
									return h("div", timeStr == "" ? "设备未校时" : timeStr);
								} 
							} catch (err) {
								return h("div", "JSON格式错误");
							}
						}
					},
					{
						title: "状态",
						key: "state",
						align: "center",
						width: 100,
						render: function(h, params) {
							if(params.row.state == 0){
								return h(
								"div",
								"待下发"
								);
							}else if(params.row.state == 1){
								return h(
								"div",
								"已下发"
								);
							}else if(params.row.state == 2){
								return h(
								"div",
								"下发完成"
								);
							}

						}
					},
					{
						title: "操作",
						slot: "action",
						align: "center",
						width: 100
					}
				],
			};
		},
		created() {
			this.getBoxProfile()
			this.getMessage()
		},
		mounted() {

		},
		methods: {
			dateFtt(fmt, date) {
				return global.dateFtt(fmt, new Date(date));
			},
			getBoxProfile() {
				let that = this;
				that.loading = true;
				$.ajax({
					url: "/api/alarm/admin/message/getNBProfile",
					async: false,
					success: function(result) {
						if (!result.success) {
							that.$Notice.error({
								title: "异常",
								desc: result.msg
							});
							return;
						}

						that.boxProfile = result.data;
					},
					error: function() {
						that.$Notice.error({
							title: "异常",
							desc: "网络异常"
						});
					},
					complete: function() {
						that.loading = false;
					}
				});
			},
			// 显示条件检索页面
			showSearch() {
				this.searchModal = true;
			},
			searchByCondition() {
				this.requestBody = {};
				for (let i in this.selectedConditions) {
					let selectedCondition = this.selectedConditions[i]
					switch (selectedCondition) {
						case 'happenTime':
							let happenTimeBegin = this.condition.happenTimeRange[0];
							if (happenTimeBegin != '') {
								this.requestBody['happenTimeBegin'] = global.dateFtt('yyyy-MM-dd hh:mm:ss',
									happenTimeBegin);
							}
							let happenTimeEnd = this.condition.happenTimeRange[1];
							if (happenTimeEnd != '') {
								this.requestBody['happenTimeEnd'] = global.dateFtt('yyyy-MM-dd hh:mm:ss', happenTimeEnd);
							}
							break;
						default:
							let value = this.condition[selectedCondition];
							if (value == null || value == '') {
								break;
							}

							this.requestBody[selectedCondition] = value;
							break;
					}
				}

				this.loading = true;
				this.searchModal = false;
				this.currentPage = 1;
				this.getMessage();
			},
			getMessage() {
				let that = this;
				if (localStorage.getItem("isAdmin") != "true") {
				that.requestBody["companyNum"] = localStorage.getItem("personnelGroverningBodyId");
    			}
				that.requestBody["type"]=1;
				$.ajax({
					url: "/api/alarm/admin/message/getParamSetList?currentPage=" +
						that.currentPage +
						"&pageSize=" +
						that.pageSize,
					type: "post",
					data: that.requestBody,
					mainType:'paramSet',
					success: function(result) {
						if (!result.success) {
							that.$Notice.error({
								title: "异常",
								desc: result.msg
							});
							return;
						}

						that.data1 = result.data.list;
						that.totalRows = result.data.totalRows;
						that.loading = false;
					},
					error: function(textStatus) {
						that.loading = false;
						that.$Notice.error({
							title: "异常",
							desc: "网络不通"
						});
					}
				});
			},
			changePageSize(pageSize) {
				this.pageSize = pageSize;
				this.request();
			},
			changePage(index) {
				this.currentPage = index;
				this.loading = true;
				this.getMessage();
			},
			convertData(data, type, enums) {
				let result = data;
				if (type == "Time") {
					result = global.dateFtt("yyyy-MM-dd hh:mm:ss", new Date(data * 1000));
				} else if (type == "Enum") {
					result = enums[data] == null ? data : enums[data];
				}
				return result;
			},
			showData(row, index) {
				// 遍历数据集拼接HTML
				let html = "";
				let that = this;

				let mainType = row.mainType;
				let subType = row.subType;

				try {
					html =
						"<table style='border:1px solid #C0C0C0; text-align: center;width: 100%; table-layout:fixed;'>";
					let amount = 0;
					let data = JSON.parse(row.content);
					Object.keys(data).forEach(function(key) {
						if (that.boxProfile[mainType] == null ||
							that.boxProfile[mainType][subType] == null ||
							that.boxProfile[mainType][subType]["params"][key] == null) {
              return;
							// throw new Error("JSON格式错误");
						}

						if (amount % 2 == 0) {
							html += "<tr >";
						}
						let keyObj = that.boxProfile[mainType][subType]["params"][key];
						html += "<td style='margin-top:2px; border: 1px solid #C0C0C0;word-wrap:break-word;'>" +
							keyObj.cn + "</td>";
						html += "<td style='margin-top:2px; border: 1px solid #C0C0C0;word-wrap:break-word;'>" +
							that.convertData(data[key], keyObj.type, keyObj.enum) + " " + (keyObj.unit == null ?
								"" : keyObj.unit) + "</td>";
						if (amount % 2 == 1) {
							html += "</tr>";
						}
						amount++;
					});
					html += "</table>";
					that.selectDataHtml = html;
					that.selectData = data;
				} catch (err) {
					console.log(err);
					that.selectDataHtml = "<div>JSON格式错误</div>";
					that.selectData = row.content;
					html = that.selectDataHtml;
				}

				that.$Notice.open({
					title: "存储编号:" + row.id + "\t设备编号:" + row.mac,
					render: h => {
						return h("div", {
							on: {},
							style: {
								height: "100%",
								width: "100%"
							},
							domProps: {
								innerHTML: html
							}
						});
					},
					duration: 20
				});
			}
		},
	};
</script>

<style>
	.check_group>div {
		margin-bottom: 10px;
	}

	.check_group>div>label {
		width: 100px;
	}

	.check_group>div>div {
		width: 200px;
	}

	.ivu-date-picker {
		width: 100%;
	}
</style>
